import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import seasonAppIcon from '../../../utilities/images/seasonAppIcon.jpg';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';

interface SeasonAppDialogProps {
    open: boolean;
    onClose: () => void;
}

const SeasonAppDialog: React.FC<SeasonAppDialogProps> = ({ open, onClose }) => {
  const isCompactScreen = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isCompactScreen}
      TransitionComponent={SlideUpTransition}
      sx={{
        '& .MuiDialog-paper': {
          margin: isCompactScreen ? 0 : 2,
          width: isCompactScreen ? '100vw' : 'auto',
          maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
          maxHeight: isCompactScreen ? '100dvh' : '95dvh',
          borderRadius: isCompactScreen ? 0 : 3,
          overflow: isCompactScreen ? 'auto' : 'hidden',
        },
      }}
    >
      <div className="card">
        <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
        
        <div className="title">{t("projectDialogs.seasonApp.title")}</div>
        
        <div className="card-content">
          <ImageCarousel images={[seasonAppIcon]} alt={t("projectDialogs.seasonApp.title")} />
          
          <div className="description">
            <div className="left-box">
              {t("projectDialogs.seasonApp.description")}
            </div>
            
            <div className="right-box">
              <div>Vue 3</div>
              <div>Firebase</div>
              <div>TypeScript</div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SeasonAppDialog;
